import { isObj } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { set } from 'lib/sequence/component/state/value'

const isCode = (obj: any) => isObj(obj)
  && typeof obj === 'object'
  && obj.serial
  && obj.license_counter
  && obj.duration_months
  && obj.signature

/**
 * Checks whether the user's clipboard contains a valid code and,
 * if that's the case, insert it into the code field.
 *
 * @param module current module
 */
export default (module: Gaia.AppModule.Spec) => (component: Gaia.Component.Spec) => async (...args: any[]) => {
  const clipboard = module[G.ADAPTER][G.CLIPBOARD]
  const { code } = find(component)
  const text = await clipboard.getText()

  console.log('clipboardText', text)

  try {
    const json = JSON.parse(text)

    if (isCode(json)) {
      set(code, text)
    }

  } catch (ignored) {}

  return args
}
